import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "space-y-6 p-6" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "text-3xl font-bold text-gray-900" }
const _hoisted_4 = { class: "text-gray-600 mt-1" }
const _hoisted_5 = {
  key: 0,
  class: "flex items-center justify-center py-12"
}
const _hoisted_6 = { class: "text-red-500 text-sm" }
const _hoisted_7 = { class: "grid grid-cols-1 md:grid-cols-4 gap-4" }
const _hoisted_8 = { class: "flex items-center justify-between" }
const _hoisted_9 = { class: "text-3xl font-bold text-gray-900 mt-2" }
const _hoisted_10 = { class: "w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center" }
const _hoisted_11 = { class: "flex items-center justify-between" }
const _hoisted_12 = { class: "text-3xl font-bold text-green-600 mt-2" }
const _hoisted_13 = { class: "w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center" }
const _hoisted_14 = { class: "flex items-center justify-between" }
const _hoisted_15 = { class: "text-3xl font-bold text-gray-900 mt-2" }
const _hoisted_16 = { class: "w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center" }
const _hoisted_17 = { class: "flex items-center justify-between" }
const _hoisted_18 = { class: "text-3xl font-bold text-gray-900 mt-2" }
const _hoisted_19 = { class: "w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center" }
const _hoisted_20 = { class: "flex w-full items-center justify-between border-t pt-4" }
const _hoisted_21 = { class: "flex gap-2" }
const _hoisted_22 = { class: "border-green-600 bg-green-600 text-white px-2 rounded-md" }
const _hoisted_23 = { class: "grid grid-cols-1 md:grid-cols-5 gap-4 px-2 py-4 border-b" }
const _hoisted_24 = { class: "relative" }
const _hoisted_25 = { class: "overflow-x-auto" }
const _hoisted_26 = { class: "w-full" }
const _hoisted_27 = { class: "divide-y divide-gray-200" }
const _hoisted_28 = { class: "px-6 py-4" }
const _hoisted_29 = { class: "flex items-center gap-3" }
const _hoisted_30 = { class: "w-10 h-10 rounded-full bg-gradient-to-br from-sky-700 to-sky-900 flex items-center justify-center text-white font-semibold text-sm" }
const _hoisted_31 = { class: "font-medium text-gray-900" }
const _hoisted_32 = { class: "text-sm text-gray-600" }
const _hoisted_33 = { class: "px-6 py-4" }
const _hoisted_34 = { class: "font-mono text-sm font-medium text-gray-900" }
const _hoisted_35 = { class: "text-sm text-gray-600" }
const _hoisted_36 = { class: "px-6 py-4" }
const _hoisted_37 = { class: "font-medium text-gray-900" }
const _hoisted_38 = { class: "px-6 py-4" }
const _hoisted_39 = { class: "font-medium text-gray-900" }
const _hoisted_40 = { class: "text-sm text-gray-600" }
const _hoisted_41 = { class: "px-6 py-4" }
const _hoisted_42 = { class: "text-sm text-gray-900" }
const _hoisted_43 = {
  key: 0,
  class: "text-sm text-gray-600"
}
const _hoisted_44 = { class: "px-6 py-4" }
const _hoisted_45 = { class: "flex items-center gap-2" }
const _hoisted_46 = { class: "text-sm font-medium" }
const _hoisted_47 = { class: "px-6 py-4" }
const _hoisted_48 = { class: "flex items-center gap-2" }
const _hoisted_49 = {
  key: 0,
  class: "space-y-6 mt-4"
}
const _hoisted_50 = { class: "grid grid-cols-3 gap-4" }
const _hoisted_51 = { class: "p-3 bg-white rounded-lg" }
const _hoisted_52 = { class: "font-semibold text-gray-900" }
const _hoisted_53 = { class: "p-3 bg-white rounded-lg" }
const _hoisted_54 = { class: "font-semibold font-mono text-gray-900" }
const _hoisted_55 = { class: "p-3 bg-white rounded-lg" }
const _hoisted_56 = { class: "font-semibold text-gray-900" }
const _hoisted_57 = { class: "p-3 bg-white rounded-lg" }
const _hoisted_58 = { class: "font-semibold text-gray-900" }
const _hoisted_59 = { class: "p-3 bg-white rounded-lg" }
const _hoisted_60 = { class: "font-semibold text-gray-900" }
const _hoisted_61 = { class: "p-3 bg-white rounded-lg" }
const _hoisted_62 = { class: "font-semibold text-gray-900" }
const _hoisted_63 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_64 = { class: "p-3 bg-white rounded-lg" }
const _hoisted_65 = { class: "font-semibold text-gray-900" }
const _hoisted_66 = { class: "p-3 bg-white rounded-lg" }
const _hoisted_67 = { class: "font-semibold text-gray-900" }
const _hoisted_68 = { class: "p-3 bg-white rounded-lg col-span-2" }
const _hoisted_69 = { class: "font-semibold text-gray-900" }
const _hoisted_70 = { class: "grid grid-cols-3 gap-4" }
const _hoisted_71 = { class: "p-3 bg-white rounded-lg" }
const _hoisted_72 = { class: "font-semibold font-mono text-gray-900" }
const _hoisted_73 = { class: "p-3 bg-white rounded-lg" }
const _hoisted_74 = { class: "font-semibold text-gray-900" }
const _hoisted_75 = { class: "p-3 bg-white rounded-lg" }
const _hoisted_76 = { class: "font-semibold text-gray-900" }
const _hoisted_77 = { class: "p-3 bg-white rounded-lg" }
const _hoisted_78 = { class: "font-semibold text-gray-900" }
const _hoisted_79 = { class: "p-3 bg-white rounded-lg" }
const _hoisted_80 = { class: "font-semibold text-gray-900" }
const _hoisted_81 = { class: "p-3 bg-white rounded-lg" }
const _hoisted_82 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_83 = { class: "p-3 bg-white rounded-lg" }
const _hoisted_84 = { class: "font-semibold text-gray-900" }
const _hoisted_85 = { class: "p-3 bg-white rounded-lg" }
const _hoisted_86 = { class: "font-semibold font-mono text-gray-900" }
const _hoisted_87 = { class: "p-3 bg-white rounded-lg" }
const _hoisted_88 = { class: "font-semibold text-gray-900" }
const _hoisted_89 = { class: "p-3 bg-white rounded-lg" }
const _hoisted_90 = { class: "font-semibold text-gray-900" }
const _hoisted_91 = {
  key: 0,
  class: "text-center py-12"
}
const _hoisted_92 = {
  key: 0,
  class: "bg-gray-50 px-6 py-4 border-t border-gray-200 flex items-center justify-between"
}
const _hoisted_93 = { class: "text-sm text-gray-700" }
const _hoisted_94 = { class: "font-medium" }
const _hoisted_95 = { class: "font-medium" }
const _hoisted_96 = { class: "font-medium" }
const _hoisted_97 = { class: "flex gap-2" }

import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import {
  Card,
  CardContent,
} from '@/components/ui/card';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import {
  useFetchMedicalSchemeHealthSeekers
} from '@/hooks/use-health-insurances';
import { useHealthSeekersStore } from '@/store/use-health-seekers-store';
import { useMedicalSchemesStore } from '@/store/use-medical-schemes-store';
import { useTariffCodeStore } from '@/store/use-tariff-codes-store';
import { parseHealthSeekerData } from '@/utils/utils';
import {
  Activity,
  AlertCircle,
  ArrowLeft,
  Building2,
  Calendar,
  Eye,
  FileText,
  Search,
  SettingsIcon,
  Users
} from 'lucide-vue-next';
import { storeToRefs } from 'pinia';
import { computed, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';



// Get store

export default /*@__PURE__*/_defineComponent({
  __name: 'SchemeDashboardView',
  props: {
    schemeId: {}
  },
  setup(__props: any) {

const tariffCodesStore = useTariffCodeStore();
const medicalSchemeStore = useMedicalSchemesStore();
const healthSeekersStore = useHealthSeekersStore();

// Destructure state with storeToRefs
const { medicalScheme } = storeToRefs(medicalSchemeStore);

// Get route to access params
const route = useRoute();

// Router
const router = useRouter();

// Props
const props = __props;

// Use schemeId from props or route params [TODO: Can get Scheme-Id from the medicalSchemeStore]
const schemeId = computed(() => props.schemeId || route.params.schemeId as string);

// Filters
const searchQuery = ref('');
const selectedFunder = ref('');
const selectedStatus = ref('');
const selectedYear = ref('');
const selectedClient = ref<any>(null);

// Pagination
const currentPage = ref(1);
const itemsPerPage = ref(15);
const currentYear = new Date().getFullYear();
const previousYear = currentYear - 1;

// Fetch clients data
const {
  data: fetchedData,
  isLoading, 
  isError, 
  error, 
  refetch 
} = useFetchMedicalSchemeHealthSeekers(schemeId.value, null)

// Use computed to reactively access the data
const clients = computed(() => fetchedData.value || [])

// Filtered clients
const filteredClients = computed(() => {
  let filtered = clients.value

  // Search filter
  if (searchQuery.value) {
    const query = searchQuery.value.toLowerCase()
    filtered = filtered.filter((item: any) =>
      item.client.first_name.toLowerCase().includes(query) ||
      item.client.last_name.toLowerCase().includes(query) ||
      item.membership_number.includes(query) ||
      item.client.email?.toLowerCase().includes(query) ||
      item.client.id_number?.includes(query) ||
      item.funder.name.toLowerCase().includes(query)
    )
  }

  // Funder filter
  if (selectedFunder.value && selectedFunder.value !== 'all') {
    filtered = filtered.filter((item: any) => item.funder.funder.name === selectedFunder.value)
  }

  // Status filter
  if (selectedStatus.value && selectedStatus.value !== 'all') {
    const isActive = selectedStatus.value === 'active'
    filtered = filtered.filter((item: any) => item.is_active === isActive)
  }

  // Year filter
  if (selectedYear.value && selectedYear.value !== 'all') {
    filtered = filtered.filter((item: any) => item.date_enrolled.startsWith(selectedYear.value))
  }

  return filtered
})

// Unique funders
const uniqueFunders = computed(() => {
  const funders = clients.value.map((c: any) => c.funder.funder.name)
  return [...new Set(funders)]
})

// Unique years
const uniqueYears = computed(() => {
  const years = clients.value.map((c: any) => c.date_enrolled.substring(0, 4))
  return [...new Set(years)].sort((a, b) => parseInt(b) - parseInt(a))
})

// Stats
const stats = computed(() => ({
  total: filteredClients.value.length,
  active: filteredClients.value.filter((c: any) => c.is_active).length,
  enrolled2024: filteredClients.value.filter((c: any) => c.date_enrolled.startsWith('2024')).length,
  funders: uniqueFunders.value.length
}))

// Pagination
const totalPages = computed(() => {
  return Math.ceil(filteredClients.value.length / itemsPerPage.value)
})

const startIndex = computed(() => {
  return (currentPage.value - 1) * itemsPerPage.value
})

const endIndex = computed(() => {
  return startIndex.value + itemsPerPage.value
})

const paginatedClients = computed(() => {
  return filteredClients.value.slice(startIndex.value, endIndex.value)
})

const displayPages = computed(() => {
  const pages = []
  const maxPagesToShow = 5
  let startPage = Math.max(1, currentPage.value - Math.floor(maxPagesToShow / 2))
  let endPage = Math.min(totalPages.value, startPage + maxPagesToShow - 1)

  if (endPage - startPage < maxPagesToShow - 1) {
    startPage = Math.max(1, endPage - maxPagesToShow + 1)
  }

  for (let i = startPage; i <= endPage; i++) {
    pages.push(i)
  }

  return pages
})

// Format date
const formatDate = (dateStr: string | null) => {
  if (!dateStr) return '-'
  return new Date(dateStr).toLocaleDateString('en-ZA', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  })
}

// Get status color
const getStatusColor = (isActive: boolean) => {
  return isActive ? 'bg-green-500' : 'bg-red-500'
}

const handleFetchTariffRates = (applicableYear:number) => {
  tariffCodesStore.setApplicableYear(applicableYear.toString());
  console.log(`Scheme-Id: ${schemeId.value}`);
  console.log(`Applicable Year: ${tariffCodesStore.applicableYear}`);
  router.push(`/scheme-tariff-rates-dashboard/${schemeId.value}`)
}

const resetFilters = () => {
  searchQuery.value = ''
  selectedFunder.value = 'all'
  selectedStatus.value = 'all'
  selectedYear.value = 'all'
  currentPage.value = 1
}

const viewDetails = (client: any) => {
  selectedClient.value = client
}

const handleViewTreatmentPlan = (client: any) => {
  const healthSeeker = parseHealthSeekerData(client);

  console.log('Manage Treatment Plan for client:', healthSeeker);
  // Update Health Seeker Store
  healthSeekersStore.setHealthSeeker(healthSeeker)
  router.push(`/treatment-plan`);
}

const previousPage = () => {
  if (currentPage.value > 1) {
    currentPage.value--
  }
}

const nextPage = () => {
  if (currentPage.value < totalPages.value) {
    currentPage.value++
  }
}

const getInitials = (client: any) => {
  const first = client.first_name?.[0] || ''
  const last = client.last_name?.[0] || ''
  return `${first}${last}`.toUpperCase()
}

// Get title text
const getTitleText = (titleId: number) => {
  const titles: Record<number, string> = {
    1: 'Mr',
    2: 'Mrs',
    3: 'Ms',
    4: 'Dr',
    5: 'Prof'
  }
  return titles[titleId] || ''
}

// Get sex text
const getSexText = (sexId: number) => {
  const sexes: Record<number, string> = {
    1: 'Male',
    2: 'Female',
    3: 'Other'
  }
  return sexes[sexId] || ''
}

const handleAdHocClicked = () => {
  router.push(
    {name: 'programmePhases', 
    params: { schemeId: schemeId.value }
  });
}
// Watch for data changes
watch(fetchedData, (newData) => {
  console.log('Clients data changed:', newData)
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(medicalScheme)?.name) + " Members Management", 1),
        _createElementVNode("p", _hoisted_4, "View and manage " + _toDisplayString(_unref(medicalScheme)?.name) + " enrolled members", 1)
      ]),
      _createElementVNode("div", null, [
        _createVNode(_unref(Button), {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back())),
          class: "flex items-center border border-gray-300 bg-gray-200 hover:bg-sky-700 hover:text-white"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ArrowLeft)),
            _cache[9] || (_cache[9] = _createTextVNode(" Back ", -1))
          ]),
          _: 1
        })
      ])
    ]),
    (_unref(isLoading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[10] || (_cache[10] = [
          _createElementVNode("div", { class: "text-center" }, [
            _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-b-2 border-slate-600 mx-auto mb-4" }),
            _createElementVNode("p", { class: "text-gray-600" }, "Loading clients...")
          ], -1)
        ]))]))
      : (_unref(isError))
        ? (_openBlock(), _createBlock(_unref(Card), {
            key: 1,
            class: "border-red-200 bg-red-50"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(CardContent), { class: "flex flex-col items-center justify-center py-12" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AlertCircle), { class: "h-12 w-12 text-red-600 mb-4" }),
                  _cache[12] || (_cache[12] = _createElementVNode("p", { class: "text-red-600 font-semibold mb-2" }, "Error loading clients", -1)),
                  _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(error)?.message), 1),
                  _createVNode(_unref(Button), {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(refetch)())),
                    variant: "outline",
                    class: "mt-4 border-red-600 text-red-600 hover:bg-red-600 hover:text-white"
                  }, {
                    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                      _createTextVNode(" Retry ", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (clients.value.length > 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_unref(Card), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(CardContent), { class: "pt-6" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", null, [
                            _cache[13] || (_cache[13] = _createElementVNode("p", { class: "text-sm font-medium text-gray-600" }, "Total Clients", -1)),
                            _createElementVNode("p", _hoisted_9, _toDisplayString(stats.value.total), 1)
                          ]),
                          _createElementVNode("div", _hoisted_10, [
                            _createVNode(_unref(Users), { class: "h-6 w-6 text-blue-600" })
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Card), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(CardContent), { class: "pt-6" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", null, [
                            _cache[14] || (_cache[14] = _createElementVNode("p", { class: "text-sm font-medium text-gray-600" }, "Active Clients", -1)),
                            _createElementVNode("p", _hoisted_12, _toDisplayString(stats.value.active), 1)
                          ]),
                          _createElementVNode("div", _hoisted_13, [
                            _createVNode(_unref(Activity), { class: "h-6 w-6 text-green-600" })
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Card), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(CardContent), { class: "pt-6" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", null, [
                            _cache[15] || (_cache[15] = _createElementVNode("p", { class: "text-sm font-medium text-gray-600" }, "Enrolled 2024", -1)),
                            _createElementVNode("p", _hoisted_15, _toDisplayString(stats.value.enrolled2024), 1)
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_unref(Calendar), { class: "h-6 w-6 text-purple-600" })
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Card), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(CardContent), { class: "pt-6" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", null, [
                            _cache[16] || (_cache[16] = _createElementVNode("p", { class: "text-sm font-medium text-gray-600" }, "Funders", -1)),
                            _createElementVNode("p", _hoisted_18, _toDisplayString(stats.value.funders), 1)
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            _createVNode(_unref(Building2), { class: "h-6 w-6 text-orange-600" })
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_20, [
                _cache[20] || (_cache[20] = _createElementVNode("div", null, [
                  _createElementVNode("h1", { class: "text-2xl" }, "Members List")
                ], -1)),
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_unref(Button), {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (handleFetchTariffRates(previousYear))),
                    class: "flex gap-2 border bg-transparent border-sky-700 text-sky-800 hover:bg-sky-800 hover:text-white"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", { class: "bg-sky-700 px-2 text-white rounded-md" }, _toDisplayString(previousYear)),
                      _cache[17] || (_cache[17] = _createTextVNode(" | Tariff Rates ", -1))
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Button), {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (handleFetchTariffRates(_unref(currentYear)))),
                    class: "flex gap-2 border bg-transparent text-green-700 border-green-600 hover:bg-green-700 hover:text-white"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(currentYear)), 1),
                      _cache[18] || (_cache[18] = _createTextVNode(" | Tariff Rates ", -1))
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Button), {
                    onClick: handleAdHocClicked,
                    variant: "outline",
                    class: "gap-1 border-yellow-500 cursor-pointer hover:bg-yellow-500 hover:text-white"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(SettingsIcon), { class: "h-4 w-4" }),
                      _cache[19] || (_cache[19] = _createTextVNode(" AD HOC ", -1))
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createVNode(_unref(Card), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(CardContent), { class: "p-0" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(_unref(Search), { class: "absolute left-3 top-3 h-4 w-4 text-gray-400" }),
                          _createVNode(_unref(Input), {
                            modelValue: searchQuery.value,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((searchQuery).value = $event)),
                            placeholder: "Search clients...",
                            class: "pl-9"
                          }, null, 8, ["modelValue"])
                        ]),
                        _createVNode(_unref(Select), {
                          modelValue: selectedFunder.value,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedFunder).value = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(SelectTrigger), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(SelectValue), { placeholder: "All Funders" })
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(SelectContent), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(SelectItem), { value: "all" }, {
                                  default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                    _createTextVNode("All Funders", -1)
                                  ]))]),
                                  _: 1
                                }),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uniqueFunders.value, (funder) => {
                                  return (_openBlock(), _createBlock(_unref(SelectItem), {
                                    key: funder,
                                    value: funder
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(funder), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_unref(Select), {
                          modelValue: selectedYear.value,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedYear).value = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(SelectTrigger), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(SelectValue), { placeholder: "All Years" })
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(SelectContent), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(SelectItem), { value: "all" }, {
                                  default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                    _createTextVNode("All Years", -1)
                                  ]))]),
                                  _: 1
                                }),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uniqueYears.value, (year) => {
                                  return (_openBlock(), _createBlock(_unref(SelectItem), {
                                    key: year,
                                    value: year
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(year), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_unref(Select), {
                          modelValue: selectedStatus.value,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((selectedStatus).value = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(SelectTrigger), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(SelectValue), { placeholder: "All Status" })
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(SelectContent), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(SelectItem), { value: "all" }, {
                                  default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                    _createTextVNode("All Status", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _createVNode(_unref(SelectItem), { value: "active" }, {
                                  default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                                    _createTextVNode("Active", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _createVNode(_unref(SelectItem), { value: "inactive" }, {
                                  default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                                    _createTextVNode("Inactive", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_unref(Button), {
                          onClick: resetFilters,
                          variant: "outline",
                          class: "w-full"
                        }, {
                          default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                            _createTextVNode(" Reset Filters ", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("table", _hoisted_26, [
                          _cache[53] || (_cache[53] = _createElementVNode("thead", { class: "bg-gray-50 border-b" }, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", { class: "px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase" }, "Member"),
                              _createElementVNode("th", { class: "px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase" }, "Membership"),
                              _createElementVNode("th", { class: "px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase" }, "Funder"),
                              _createElementVNode("th", { class: "px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase" }, "Option"),
                              _createElementVNode("th", { class: "px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase" }, "Date Enrolled"),
                              _createElementVNode("th", { class: "px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase" }, "Status"),
                              _createElementVNode("th", { class: "px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase" }, "Actions")
                            ])
                          ], -1)),
                          _createElementVNode("tbody", _hoisted_27, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedClients.value, (item) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: item.id,
                                class: "hover:bg-gray-50 transition-colors"
                              }, [
                                _createElementVNode("td", _hoisted_28, [
                                  _createElementVNode("div", _hoisted_29, [
                                    _createElementVNode("div", _hoisted_30, _toDisplayString(getInitials(item.client)), 1),
                                    _createElementVNode("div", null, [
                                      _createElementVNode("div", _hoisted_31, _toDisplayString(getTitleText(item.client.title)) + " " + _toDisplayString(item.client.first_name) + " " + _toDisplayString(item.client.last_name), 1),
                                      _createElementVNode("div", _hoisted_32, "ID: " + _toDisplayString(item.client.id_number || item.client.passport_number || '-'), 1)
                                    ])
                                  ])
                                ]),
                                _createElementVNode("td", _hoisted_33, [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_34, _toDisplayString(item.membership_number), 1),
                                    _createElementVNode("div", _hoisted_35, "Dep: " + _toDisplayString(item.dependant_key), 1)
                                  ])
                                ]),
                                _createElementVNode("td", _hoisted_36, [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_37, _toDisplayString(item.funder.funder.name), 1),
                                    _createVNode(_unref(Badge), {
                                      variant: "outline",
                                      class: "font-mono text-xs border border-yellow-700 mt-1 py-0"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.funder.funder.scheme_code), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ])
                                ]),
                                _createElementVNode("td", _hoisted_38, [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_39, _toDisplayString(item.funder.code), 1),
                                    _createElementVNode("div", _hoisted_40, _toDisplayString(item.funder.name), 1)
                                  ])
                                ]),
                                _createElementVNode("td", _hoisted_41, [
                                  _createElementVNode("div", _hoisted_42, _toDisplayString(formatDate(item.date_enrolled)), 1),
                                  (item.date_joined)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, "Joined: " + _toDisplayString(formatDate(item.date_joined)), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("td", _hoisted_44, [
                                  _createElementVNode("div", _hoisted_45, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(['w-2 h-2 rounded-full', getStatusColor(item.is_active)])
                                    }, null, 2),
                                    _createElementVNode("span", _hoisted_46, _toDisplayString(item.is_active ? 'Active' : 'Inactive'), 1)
                                  ])
                                ]),
                                _createElementVNode("td", _hoisted_47, [
                                  _createElementVNode("div", _hoisted_48, [
                                    _createVNode(_unref(Dialog), null, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(DialogTrigger), { "as-child": "" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(Button), {
                                              class: "border border-[#b69831]",
                                              variant: "ghost",
                                              size: "sm",
                                              onClick: ($event: any) => (viewDetails(item)),
                                              title: "View Details"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(Eye), { class: "h-4 w-4" }),
                                                _cache[27] || (_cache[27] = _createTextVNode(" View ", -1))
                                              ]),
                                              _: 1
                                            }, 8, ["onClick"])
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_unref(DialogContent), { class: "bg-slate-100 w-[70vw] max-w-none sm:max-w-none max-h-[80vh] overflow-y-auto" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(DialogHeader), null, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(DialogTitle), null, {
                                                  default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                                                    _createTextVNode("Client Details", -1)
                                                  ]))]),
                                                  _: 1
                                                }),
                                                _createVNode(_unref(DialogDescription), null, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(" Complete information for " + _toDisplayString(selectedClient.value?.client?.first_name) + " " + _toDisplayString(selectedClient.value?.client?.last_name), 1)
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            (selectedClient.value)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                                  _createElementVNode("div", null, [
                                                    _cache[35] || (_cache[35] = _createElementVNode("h4", { class: "text-lg font-semibold mb-3" }, "Personal Information", -1)),
                                                    _createElementVNode("div", _hoisted_50, [
                                                      _createElementVNode("div", _hoisted_51, [
                                                        _cache[29] || (_cache[29] = _createElementVNode("p", { class: "text-sm text-gray-600" }, "Full Name", -1)),
                                                        _createElementVNode("p", _hoisted_52, _toDisplayString(getTitleText(selectedClient.value?.client?.title)) + " " + _toDisplayString(selectedClient.value?.client?.first_name) + " " + _toDisplayString(selectedClient.value?.client?.middle_name || '') + " " + _toDisplayString(selectedClient.value?.client?.last_name), 1)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_53, [
                                                        _cache[30] || (_cache[30] = _createElementVNode("p", { class: "text-sm text-gray-600" }, "ID Number", -1)),
                                                        _createElementVNode("p", _hoisted_54, _toDisplayString(selectedClient.value?.client?.id_number || '-'), 1)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_55, [
                                                        _cache[31] || (_cache[31] = _createElementVNode("p", { class: "text-sm text-gray-600" }, "Passport", -1)),
                                                        _createElementVNode("p", _hoisted_56, _toDisplayString(selectedClient.value?.client?.passport_number || '-'), 1)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_57, [
                                                        _cache[32] || (_cache[32] = _createElementVNode("p", { class: "text-sm text-gray-600" }, "Date of Birth", -1)),
                                                        _createElementVNode("p", _hoisted_58, _toDisplayString(formatDate(selectedClient.value?.client?.date_of_birth) || '-'), 1)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_59, [
                                                        _cache[33] || (_cache[33] = _createElementVNode("p", { class: "text-sm text-gray-600" }, "Sex", -1)),
                                                        _createElementVNode("p", _hoisted_60, _toDisplayString(getSexText(selectedClient.value?.client?.sex) || '-'), 1)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_61, [
                                                        _cache[34] || (_cache[34] = _createElementVNode("p", { class: "text-sm text-gray-600" }, "Language", -1)),
                                                        _createElementVNode("p", _hoisted_62, _toDisplayString(selectedClient.value?.client?.language?.language || '-'), 1)
                                                      ])
                                                    ])
                                                  ]),
                                                  _createElementVNode("div", null, [
                                                    _cache[39] || (_cache[39] = _createElementVNode("h4", { class: "text-lg font-semibold mb-3" }, "Contact Information", -1)),
                                                    _createElementVNode("div", _hoisted_63, [
                                                      _createElementVNode("div", _hoisted_64, [
                                                        _cache[36] || (_cache[36] = _createElementVNode("p", { class: "text-sm text-gray-600" }, "Email", -1)),
                                                        _createElementVNode("p", _hoisted_65, _toDisplayString(selectedClient.value?.client?.email || '-'), 1)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_66, [
                                                        _cache[37] || (_cache[37] = _createElementVNode("p", { class: "text-sm text-gray-600" }, "Mobile", -1)),
                                                        _createElementVNode("p", _hoisted_67, _toDisplayString(selectedClient.value?.client?.mobile_number || '-'), 1)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_68, [
                                                        _cache[38] || (_cache[38] = _createElementVNode("p", { class: "text-sm text-gray-600" }, "Address", -1)),
                                                        _createElementVNode("p", _hoisted_69, _toDisplayString([
                                    selectedClient.value?.client?.unit_number,
                                    selectedClient.value?.client?.building_name,
                                    selectedClient.value?.client?.street_number,
                                    selectedClient.value?.client?.street_name,
                                    selectedClient.value?.client?.suburb,
                                    selectedClient.value?.client?.city,
                                    selectedClient.value?.client?.postal_code
                                  ].filter(Boolean).join(', ') || '-'), 1)
                                                      ])
                                                    ])
                                                  ]),
                                                  _createElementVNode("div", null, [
                                                    _cache[46] || (_cache[46] = _createElementVNode("h4", { class: "text-lg font-semibold mb-3" }, "Membership Details", -1)),
                                                    _createElementVNode("div", _hoisted_70, [
                                                      _createElementVNode("div", _hoisted_71, [
                                                        _cache[40] || (_cache[40] = _createElementVNode("p", { class: "text-sm text-gray-600" }, "Membership Number", -1)),
                                                        _createElementVNode("p", _hoisted_72, _toDisplayString(selectedClient.value.membership_number), 1)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_73, [
                                                        _cache[41] || (_cache[41] = _createElementVNode("p", { class: "text-sm text-gray-600" }, "Dependant Key", -1)),
                                                        _createElementVNode("p", _hoisted_74, _toDisplayString(selectedClient.value.dependant_key), 1)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_75, [
                                                        _cache[42] || (_cache[42] = _createElementVNode("p", { class: "text-sm text-gray-600" }, "Identifier", -1)),
                                                        _createElementVNode("p", _hoisted_76, _toDisplayString(selectedClient.value.identifier), 1)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_77, [
                                                        _cache[43] || (_cache[43] = _createElementVNode("p", { class: "text-sm text-gray-600" }, "Date Enrolled", -1)),
                                                        _createElementVNode("p", _hoisted_78, _toDisplayString(formatDate(selectedClient.value.date_enrolled)), 1)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_79, [
                                                        _cache[44] || (_cache[44] = _createElementVNode("p", { class: "text-sm text-gray-600" }, "Date Joined", -1)),
                                                        _createElementVNode("p", _hoisted_80, _toDisplayString(formatDate(selectedClient.value.date_joined)), 1)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_81, [
                                                        _cache[45] || (_cache[45] = _createElementVNode("p", { class: "text-sm text-gray-600" }, "Status", -1)),
                                                        _createVNode(_unref(Badge), {
                                                          variant: selectedClient.value.is_active ? 'default' : 'destructive'
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(selectedClient.value.is_active ? 'Active' : 'Inactive'), 1)
                                                          ]),
                                                          _: 1
                                                        }, 8, ["variant"])
                                                      ])
                                                    ])
                                                  ]),
                                                  _createElementVNode("div", null, [
                                                    _cache[51] || (_cache[51] = _createElementVNode("h4", { class: "text-lg font-semibold mb-3" }, "Funder Information", -1)),
                                                    _createElementVNode("div", _hoisted_82, [
                                                      _createElementVNode("div", _hoisted_83, [
                                                        _cache[47] || (_cache[47] = _createElementVNode("p", { class: "text-sm text-gray-600" }, "Funder Name", -1)),
                                                        _createElementVNode("p", _hoisted_84, _toDisplayString(selectedClient.value.funder.funder.name), 1)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_85, [
                                                        _cache[48] || (_cache[48] = _createElementVNode("p", { class: "text-sm text-gray-600" }, "Scheme Code", -1)),
                                                        _createElementVNode("p", _hoisted_86, _toDisplayString(selectedClient.value.funder.funder.scheme_code), 1)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_87, [
                                                        _cache[49] || (_cache[49] = _createElementVNode("p", { class: "text-sm text-gray-600" }, "Option Code", -1)),
                                                        _createElementVNode("p", _hoisted_88, _toDisplayString(selectedClient.value.funder.code), 1)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_89, [
                                                        _cache[50] || (_cache[50] = _createElementVNode("p", { class: "text-sm text-gray-600" }, "Option Name", -1)),
                                                        _createElementVNode("p", _hoisted_90, _toDisplayString(selectedClient.value.funder.name), 1)
                                                      ])
                                                    ])
                                                  ])
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_unref(Button), {
                                      variant: "default",
                                      size: "sm",
                                      onClick: ($event: any) => (handleViewTreatmentPlan(item)),
                                      title: "Manage Treatment Plan",
                                      class: "ml-2 border border-[#b69831]"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(FileText), { class: "h-4 w-4 mr-1" }),
                                        _cache[52] || (_cache[52] = _createTextVNode(" Treatment Plan ", -1))
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ])
                                ])
                              ]))
                            }), 128))
                          ])
                        ]),
                        (paginatedClients.value.length === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                              _createVNode(_unref(AlertCircle), { class: "h-16 w-16 mx-auto text-gray-400 mb-4" }),
                              _cache[54] || (_cache[54] = _createElementVNode("p", { class: "text-gray-600 text-lg font-medium" }, "No clients found", -1)),
                              _cache[55] || (_cache[55] = _createElementVNode("p", { class: "text-gray-500 text-sm mt-1" }, "Try adjusting your filters", -1))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (filteredClients.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                            _createElementVNode("div", _hoisted_93, [
                              _cache[56] || (_cache[56] = _createTextVNode(" Showing ", -1)),
                              _createElementVNode("span", _hoisted_94, _toDisplayString(startIndex.value + 1), 1),
                              _cache[57] || (_cache[57] = _createTextVNode(" to ", -1)),
                              _createElementVNode("span", _hoisted_95, _toDisplayString(Math.min(endIndex.value, filteredClients.value.length)), 1),
                              _cache[58] || (_cache[58] = _createTextVNode(" of ", -1)),
                              _createElementVNode("span", _hoisted_96, _toDisplayString(filteredClients.value.length), 1),
                              _cache[59] || (_cache[59] = _createTextVNode(" results ", -1))
                            ]),
                            _createElementVNode("div", _hoisted_97, [
                              _createVNode(_unref(Button), {
                                onClick: previousPage,
                                disabled: currentPage.value === 1,
                                variant: "outline",
                                size: "sm"
                              }, {
                                default: _withCtx(() => [...(_cache[60] || (_cache[60] = [
                                  _createTextVNode(" Previous ", -1)
                                ]))]),
                                _: 1
                              }, 8, ["disabled"]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayPages.value, (page) => {
                                return (_openBlock(), _createBlock(_unref(Button), {
                                  key: page,
                                  onClick: ($event: any) => (currentPage.value = page),
                                  variant: currentPage.value === page ? 'default' : 'outline',
                                  size: "sm"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(page), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick", "variant"]))
                              }), 128)),
                              _createVNode(_unref(Button), {
                                onClick: nextPage,
                                disabled: currentPage.value === totalPages.value,
                                variant: "outline",
                                size: "sm"
                              }, {
                                default: _withCtx(() => [...(_cache[61] || (_cache[61] = [
                                  _createTextVNode(" Next ", -1)
                                ]))]),
                                _: 1
                              }, 8, ["disabled"])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ], 64))
          : (_openBlock(), _createBlock(_unref(Card), { key: 3 }, {
              default: _withCtx(() => [
                _createVNode(_unref(CardContent), { class: "flex flex-col items-center justify-center py-12" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(AlertCircle), { class: "h-12 w-12 text-gray-400 mb-4" }),
                    _cache[63] || (_cache[63] = _createElementVNode("p", { class: "text-gray-500" }, "No clients data available", -1)),
                    _createVNode(_unref(Button), {
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(refetch)())),
                      variant: "outline",
                      class: "mt-4"
                    }, {
                      default: _withCtx(() => [...(_cache[62] || (_cache[62] = [
                        _createTextVNode(" Refresh ", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
  ]))
}
}

})